//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'HDSS1',
  data () {
    return {
      form: {
        data1: ''
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        {value: '0', name: '出汗不显著，不会干扰我的日常生活'},
        {value: '1', name: '出汗是可以忍受的，偶尔会干扰我的日常生活'},
        {value: '2', name: '出汗是勉强可以忍受的，常常会干扰我的日常生活'},
        {value: '3', name: '出汗是不能忍受的，总是会干扰我的日常生活'}
      ]
    }
  },
  created () { 
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      let result = 0
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
        result += Number(form[key])
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        self.hasScore = true
        return String(result)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/HDSS1.vue